import styled from 'styled-components'

export const Item = styled.div`
  margin-bottom: var(--space-400);

  &:last-child {
    margin-bottom: 0;
  }
`

export const ItemLabel = styled.div`
  margin-bottom: var(--space-100);

  font-size: var(--font-size-300);
  color: var(--text-secondary);
`

export const ItemContent = styled.div`
  font-size: var(--font-size-400);
  color: var(--text-primary);
`
